<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01">
<div class="chapterHead">
<h2 class="chapterTitle1" style="text-indent: 0%;"><span class="bold">List of Illustrations</span></h2>
</div>
<div class="chapterBody">
<p class="bibliographyEntry" style="text-indent: -5%; margin-left: 5%;"><em class="italic">Endpapers:</em> The Coronation procession of King Edward VI. (Bridgeman Art Library: Society of Antiquaries)</p>
<ol class="ol-arabic">
<li class="listItem">‘No painting ever boasted greater’: Hans Holbein’s mural of Henry VIII. (2006 HM Queen Elizabeth II)</li>
<li class="listItem">The image of royal supremacy. (Bridgeman Art Library: Thyssen-Bornemisza Collection, Madrid)</li>
<li class="listItem">The reality. (Bridgeman Art Library: Society of Antiquaries)</li>
<li class="listItem">Jane Seymour. (Bridgeman Art Library: Kunsthistorisches Museum, Vienna)</li>
<li class="listItem">‘Little one, emulate thy father and be the heir of his virtue’. (AKG London: National Gallery of Art, Washington DC, Andrew Mellon Collection)</li>
<li class="listItem">Henry was a devoted father to his son. (2006 HM Queen Elizabeth II)</li>
<li class="listItem">Edward’s early childhood was one of carefree abandon. (AKG London: Kunstmuseum, Basel)</li>
<li class="listItem">Henry Howard, Earl of Surrey. (National Portrait Gallery)</li>
<li class="listItem">Edward at Ashridge House. (2006 HM Queen Elizabeth II)</li>
<li class="listItem">Sir John Cheke. (Getty Images)</li>
<li class="listItem">Allegory of Edward’s reign. (National Portrait Gallery)</li>
<li class="listItem">Henry VIII’s last will and testament. (National Archives)</li>
<li class="listItem">William Paget, Henry VIII’s private secretary. (National Portrait Gallery)</li>
<li class="listItem">Edward Seymour, Duke of Somerset and Edward’s uncle: portrait by Hans Holbein. (Bridgeman Art Library: Trustees of the Weston Park Foundation)</li>
<li class="listItem">Edward’s signature. (Bridgeman Art Library)</li>
<li class="listItem">Edward on the cusp of manhood. (AKG London: Louvre, Paris)</li>
<li class="listItem">Princess Mary, Edward’s elder half-sister. (National Portrait Gallery)</li>
<li class="listItem">A teenage Princess Elizabeth, Edward’s half-sister. (2006 HM Queen Elizabeth II)</li>
<li class="listItem">Katherine Parr, Henry VIII’s sixth wife. (National Portrait Gallery)</li>
<li class="listItem">Sir Thomas Seymour, Somerset’s younger brother. (National Portrait Gallery)</li>
<li class="listItem">Thomas Cranmer, Archbishop of Canterbury. (Bridgeman Art Library: Lambeth Palace)</li>
<li class="listItem">An allegory of Edward’s reign, from John Foxe’s <em class="italic">Acts and Monuments</em>, 1570. (Bridgeman Art Library)</li>
<li class="listItem">John Dudley, later Duke of Northumberland. (W&amp;N Archive)</li>
<li class="listItem">Thomas Wriothesley, Earl of Southampton. (Private Collection)</li>
<li class="listItem">A woodcut from Foxe’s <em class="italic">Acts and Monuments</em> showing Hugh Latimer preaching. (Bridgeman Art Library)</li>
<li class="listItem">A seventeenth-century woodcut of the Duke of Somerset’s execution on Tower Hill. (W&amp;N Archive)</li>
<li class="listItem">The frontispiece of the controversial 1549 Book of Common Prayer. (Bridgeman Art Library)</li>
<li class="listItem">Edward VI opening Parliament in March 1553. (2006 HM Queen Elizabeth II)</li>
<li class="listItem">Edward’s ‘devise for the succession’. (Inner Temple, Library)</li>
<li class="listItem">Lady Jane Grey, Edward’s ill-fated cousin. (Bridgeman Art Library)</li>
</ol>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466805798_fm01.vue?bea2884e